var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlashingLamp01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.78,13.74c-3.17,0-5.74-2.58-5.74-5.74s2.58-5.74,5.74-5.74S12.53,4.83,12.53,8S9.95,13.74,6.78,13.74z  M6.78,2.76C3.89,2.76,1.54,5.11,1.54,8c0,2.89,2.35,5.24,5.24,5.24s5.24-2.35,5.24-5.24C12.03,5.11,9.67,2.76,6.78,2.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.1,
    y: 7.75,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.672 7.1351)",
    className: "st2",
    width: 11.35,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.53,
    y: 2.33,
    transform: "matrix(0.7076 -0.7066 0.7066 0.7076 -3.6714 7.1275)",
    className: "st2",
    width: 0.5,
    height: 11.35
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "13.47,12.02 12.97,12.02 12.97,8.86 14.46,8.86 14.46,6.7 12.97,6.7 12.97,3.98 13.47,3.98  13.47,6.2 14.96,6.2 14.96,9.36 13.47,9.36  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashingLamp01);
export default __webpack_public_path__ + "static/media/FlashingLamp-01.e5f5ba2bca15ce57fa6f4535b0a3389c.svg";
export { ForwardRef as ReactComponent };